import { render, staticRenderFns } from "./playerCareerHighlights.vue?vue&type=template&id=b32d6d62&scoped=true"
import script from "./playerCareerHighlights.vue?vue&type=script&lang=js"
export * from "./playerCareerHighlights.vue?vue&type=script&lang=js"
import style0 from "./playerCareerHighlights.vue?vue&type=style&index=0&id=b32d6d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32d6d62",
  null
  
)

export default component.exports